module.exports = __webpack_public_path__ + "img/15.b1168550.jpg";